<ng-container *ngIf="pageData$ | async as pageData">
  <div *ngIf="pageData.salesperson" class="salesperson-nav-card">
    <img
      *ngIf="pageData.salesperson.photoUrlHttps"
      class="salesperson-photo"
      src="{{ pageData.salesperson.photoUrlHttps }}"
      alt="Salesperson Photo"
      (click)="openDialog(pageData.dialogConfig)"
    />

    <div class="contact-details">
      <div class="talk-to-vendasta contact-option" (click)="openDialog(pageData.dialogConfig)">
        {{ 'CONTACT_SALESPERSON.TALK_TO_SALES' | translate }}
      </div>

      <div class="contact-options">
        <div class="contact contact-option" (click)="openDialog(pageData.dialogConfig)">
          <mat-icon class="icon">question_answer</mat-icon>
          {{ 'CONTACT_SALESPERSON.CONTACT' | translate }}
        </div>
      </div>
    </div>
  </div>
</ng-container>
